{
  "appName": "10-10CG",
  "entryFile": "./app-entry.jsx",
  "entryName": "1010cg-application-caregiver-assistance",
  "rootUrl": "/forms/10-10cg/apply-comprehensive-family-caregiver-program",
  "productId": "4d22afe4-3f1b-4b02-bebf-18840df27cbc",
  "datadog": {
    "applicationId": "0dce7846-1a1f-4509-a0d9-d689d453151f",
    "clientToken": "pub70168626b5b3bf45d38f686506b60915",
    "service": "10-10cg",
    "toggleName": "caregiverBrowserMonitoringEnabled",
    "sessionReplaySampleRate": 100
  }
}
